import axios from "axios";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import { Button } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";
import { EboStoreState } from "context/EboStoreContext";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { FILE_MAP } from "../data";

function LoiFiles() {
	const [loiFiles, setLoiFiles] = useState([]);
	const { selectedStore, setSelectedStore } = EboStoreState();
	const tableName = "store_loi_details";
	const rowId = selectedStore?.store_code ? selectedStore?.store_code : "";
	const { setSnackBar, snackBar, setSnackBarOpen, loginUser, setLoadingOpen } = GlobalState();

	const fetchFiles = async () => {
		await axios
			.get(`/api/ebo_store_v4/get_store_files?id=${rowId}`)
			.then((res) => {
				if (res.status === 200) {
					console.log("res.data", res.data);
					setLoiFiles(res.data);
					setLoadingOpen(false);
				}
			})
			.catch((err) => {
				console.log("error", err);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: `unable to get loi files`,
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			});
	};
	useEffect(() => {
		setLoadingOpen(true);
		fetchFiles();
		setLoadingOpen(false);
	}, []);

	const handleFileDownload = async (path) => {
		try {
			const { data } = await axios.post("/api/ebo_store_v4/generate_signed_url", {
				filePath: path, // assume this comes from your DB row
			});
			console.log("DATA", data); // Open file in a new tab
			window.open(data.data, "_blank");
		} catch (error) {
			console.error("Failed to generate signed URL:", error);
			alert("Error downloading file");
		}
	};

	const LOI_FILES_FIELDS = [
		{
			field: "file_name",
			headerName: "File Name",
			minWidth: 150,
			flex: 1,
			align: "center",
			headerAlign: "center",
		},
		{
			field: "updated_by",
			headerName: "Updated By",
			minWidth: 220,
			align: "center",
			headerAlign: "center",
			flex: 1,
		},
		{
			field: "file_type",
			headerName: "Type Of File",
			minWidth: 100,
			align: "center",
			headerAlign: "center",
			flex: 1,
			renderCell: ({ row, field }) => FILE_MAP[row[field]],
		},
		{
			field: "created_at",
			headerName: "Created At",
			minWidth: 100,
			align: "center",
			headerAlign: "center",
			flex: 1,
			renderCell: ({ row, field }) => moment(row[field]).format("DD-MM-YYYY"),
		},
		{
			field: "effective_date",
			headerName: "Effective Date",
			minWidth: 100,
			align: "center",
			headerAlign: "center",
			flex: 1,
			renderCell: ({ row, field }) => moment(row[field]).format("DD-MM-YYYY"),
		},
		{
			field: "url",
			headerName: "",
			minWidth: 100,
			flex: 1,
			align: "center",
			headerAlign: "center",
			renderCell: ({ row, field }) => (
				<Button onClick={() => handleFileDownload(row[field])} startIcon={<DownloadRoundedIcon />} />
			),
		},
	];

	return (
		<Box sx={{ p: 2 }}>
			<Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: "#2c3e50" }}>
				Store FILES
			</Typography>
			<DataGrid
				rows={loiFiles}
				getRowId={(row) => row.id}
				columns={LOI_FILES_FIELDS}
				sx={{
					minHeight: 220,
					maxHeight: 300,
					width: "100%",
					border: "none",
					"& .MuiDataGrid-row": {
						cursor: "pointer",
						border: "none",
						"&:hover": {
							backgroundColor: "#f5f6fa",
						},
					},
					"& .MuiDataGrid-columnHeader": {
						cursor: "pointer",
						background: grey[300],
						fontWeight: "bold",
					},
					"& .MuiDataGrid-cell": {
						borderBottom: "1px solid #eee",
					},
				}}
				columnHeaderHeight={35}
				rowHeight={40}
				disableAutosize
				disableRowSelectionOnClick
				pageSizeOptions={[5, 10]}
				hideFooter={true}
			/>
		</Box>
	);
}

export default LoiFiles;
